export interface JwtPayload {
  exp?: number;
  [claim: string]: unknown;
}

export function decodeJwt(token: string): JwtPayload | null {
  if (typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  const payloadSegment = parts[1];
  if (!payloadSegment) return null;
  try {
    const b64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const decoded = JSON.parse(json) as unknown;
    if (!decoded || typeof decoded !== 'object') return null;
    return decoded as JwtPayload;
  } catch {
    return null;
  }
}
